import { ApiTaxRate } from '@vend/types/tax'
import { IPromise } from 'angular'
import React from 'react'
import { Button, Icon } from '@lightspeed/design-system-react'

import { useT } from '@transifex/react'
import { Sale } from '../../../models/sale'
import { useVdCurrencyFilter } from '../../../ng-compat/hooks'

import { TaxRate } from '../../util/TaxRate'
import { DisplaySaleTax } from './useDisplayTax'

type TaxRateProps = {
  removeTax: (rate: ApiTaxRate, taxGroupId: string) => IPromise<void | Sale>
  taxGroup: DisplaySaleTax // the tax group containing all the tax rates
  canRemoveTax: boolean
}

export const TaxRates = (props: TaxRateProps) => {
  const { removeTax, taxGroup, canRemoveTax } = props
  const vdCurrencyFilter = useVdCurrencyFilter()
  const t = useT()
  const rates = taxGroup.rates
  const showRemoveTaxBtn = canRemoveTax && rates.length <= 2

  return rates.map(tax => {
    const taxRate = tax.rate

    return (
      <tr key={taxRate.id} className="tax-rate">
        <td className="vd-pl5">
          <TaxRate tax={tax} />
        </td>
        <td className="tax-total">{vdCurrencyFilter(tax.total)}</td>
        <td>
          {showRemoveTaxBtn && (
            <Button
              disabled={!tax.removable}
              aria-label={t('Delete tax', { _context: 'Button' })}
              className="vd-btn vd-btn--icon-no"
              onClick={() => removeTax(taxRate, taxGroup.id)}
              modifier="icon"
              variant="supplementary"
              data-track="remove-tax"
            >
              <Icon icon="fa-trash" />
            </Button>
          )}
        </td>
      </tr>
    )
  })
}
